export default {
  // Common words
  enter: "Unesi",
  next: "Dalje",
  previous: "Prethodno",
  finish: "Završi",
  returnToWebsite: "Povratak na web-stranicu",
  complete: "Dovrši",
  submit: "Pošalji",
  cancel: "Odustani",
  yes: "Da",
  no: "Ne",
  skip: "Preskoči",
  close: "Zatvori",
  discard: "Odbaci",
  save: "Spremi",
  "thank-you": "Hvala",
  select: "Odaberi",
  hi: "Bok",
  hello: "Pozdrav",
  link: "Poveznica",
  back: "Natrag",
  view: "Prikaži",
  continue: "Nastavi",
  of: "od",

  // Client Survey Main
  "client-survey-main-thanks-note":
    "Hvala što ste odvojili vrijeme, vaše povratne informacije oblikuju našu ponudu <br /> za budućnost.",
  "client-survey-how-likely-recommend":
    "Koliko je vjerojatno da biste nas preporučili drugima?",
  "client-survey-how-likely-note":
    "Na ljestvici od 0 do 10, gdje je 0 nimalo vjerojatno, a 10 iznimno vjerojatno.",
  "client-survey-how-likely-recommend-question":
    "Koja je jedna stvar koju bismo mogli učiniti da biste nas vjerojatnije preporučili?",
  "step-of": "Korak {step} od {total}",
  step: "Korak {step}",
  "client-survey-how-satisfied-with-service": "Koliko ste zadovoljni uslugom",
  "client-survey-how-satisfied-with-service-question":
    "Koja je jedna stvar koju bismo mogli učiniti da se poboljšamo?",
  "client-survey-how-satisfied-with-food":
    "Koliko ste zadovoljni hranom koju primate od nas?",
  "client-survey-how-satisfied-with-food-question":
    "Koja je jedna stvar koju bismo mogli učiniti da se poboljšamo?",
  "client-survey-what-is-the-best-thing-about-working-with-us":
    "Koja je najbolja stvar u radu s nama? Odaberite sve što vam je važno.",
  "management-team": "Upravljački tim",
  "the-front-line-operations-team": "Operativni tim na prvoj liniji",
  "food-offering": "Ponuda hrane",
  innovation: "Inovacija",
  communication: "Komunikacija",
  "flexibility-and-responsiveness": "Fleksibilnost i odzivnost",
  billing: "Naplata",
  "health-and-hygiene-standards": "Standardi zdravlja i higijene",
  "if-other-please-specify": "Ako je drugo, navedite...",
  "based-on-the-service-we-provide-where-can-we-improve-the-most-please-select-all-that-matters":
    "Na temelju usluge koju pružamo, gdje se najviše možemo poboljšati? Odaberite sve što vam je važno.",
  "please-can-we-have-some-more-detail": "Možete li nam dati više detalja?",
  "to-help-us-understand-your-csr-priorities-please-order-in-rank-of-importance-the-following":
    "Kako bismo razumjeli vaše CSR prioritete, poredajte sljedeće prema važnosti:",
  "sustainable-ingredients": "Održivi sastojci",
  "food-waste": "Otpad od hrane",
  "local-sourcing": "Lokalna nabava",
  "people-and-communities": "Ljudi i zajednice",
  "energy-reduction": "Smanjenje potrošnje energije",
  "working-with-local-communities": "Rad s lokalnim zajednicama",
  "environmental-choices": "Ekološki izbori",
  "meat-free": "Bez mesa",
  "less-plastic": "Manje plastike",
  "would-you-like-to-be-contacted-about-your-feedback":
    "Želite li da vas kontaktiramo u vezi s vašim povratnim informacijama? Ako da, ostavite svoje kontakt podatke u nastavku",
  "full-name": "Ime i prezime",
  "email-address": "Adresa e-pošte",
  "phone-number": "Broj telefona",
  feedback: "Povratne informacije",
  "view-our-privacy-policy": "Pogledajte našu Politiku privatnosti",
  "thank-you-for-taking-time-to-complete-the-survey":
    "Hvala što ste odvojili vrijeme za ispunjavanje ankete!",

  // 404 Not Found
  "404-not-found": "404 Nije pronađeno",

  // Privacy Policy
  "privacy-policy": "Politika privatnosti",

  // Employee Web Rating Feedback Step 1
  "employee-web-rating-feedback-step-1-positive":
    "Drago nam je čuti da se osjećate pozitivno, voljeli bismo znati zašto?",
  "employee-web-rating-feedback-step-1-negative":
    "Žao nam je čuti da se ne osjećate najbolje, možete li nam reći zašto?",

  // Employee Web Rating Feedback Step 2
  "employee-web-rating-feedback-step-2-heading":
    "Postoji li još nešto što biste danas željeli podijeliti s nama?",
  "employee-web-rating-feedback-step-2-information":
    "Imate li kakvih komentara ili povratnih informacija o svom današnjem iskustvu s nama?",
  "employee-web-rating-feedback-step-2-placeholder":
    "Podijelite s nama svoje današnje iskustvo...",

  // Employee Web Rating Feedback Step 3
  "employee-web-rating-feedback-step-3-heading":
    "Želite li nekome odati priznanje?",
  "no-employees-found": "Nije pronađen nijedan zaposlenik",

  // Employee Web Rating Home
  "choose-location": "Odaberite lokaciju",
  "search-location": "Pretražite lokaciju",
  "feedback-anonymous":
    "Želite li da vaše povratne informacije ostanu anonimne?",
  "feedback-feeling-today": "Kako se danas osjećate?",

  // Employee Web Rating Thankyou Page
  "thank-you-for-your-feedback": "Hvala vam na povratnim informacijama!",
  "back-to-home": "Natrag na početnu",
  page: "Stranica",

  // Feedback Once Alert
  "feedback-once-alert":
    "Povratne informacije s ovog URL-a već su jednom dane.",

  // Front Customer Audit
  "please-answer-above-question": "Odgovorite na pitanje iznad.",
  "add-comments": "Dodajte komentare",
  "enter-answer": "Unesite odgovor",
  "add-upload-files": "Dodajte / učitajte datoteke",

  // Alphega Questions
  "did-you-buy-medicine-in-the-pharmacy-today":
    "Jeste li danas kupili lijek u ljekarni?",
  "were-you-asked-any-of-the-following":
    "Jesu li vas pitali nešto od sljedećeg:",
  "who-is-the-medicine-for": "Za koga je lijek?",
  "what-are-your-symptoms": "Koji su vaši simptomi?",
  "how-long-you-had-the-symptoms": "Koliko dugo imate simptome?",
  "what-action-you-have-already-taken": "Koje ste mjere već poduzeli?",
  "are-you-taking-any-other-medication": "Uzimate li još neke lijekove?",

  // Alphega - Other Companies Questions
  "did-you-wait-more-than-10-minutes-to-be-served":
    "Jeste li čekali više od 10 minuta da budete posluženi?",
  "were-the-products-you-wanted-in-stock":
    "Jesu li proizvodi koje ste željeli bili na zalihi?",
  "were-the-staff-friendly-and-helpful":
    "Je li osoblje bilo ljubazno i susretljivo?",
  "did-you-receive-any-advice-about-your-medicines":
    "Jeste li dobili kakav savjet o svojim lijekovima?",

  // Front Mobile Home
  "how-was-your-experience-with-us-today":
    "Kakvo je bilo vaše današnje iskustvo s nama?",

  // Front Mobile Thankyou Page
  "thank-you-for-your-time-and-your-answers":
    "Hvala vam na vremenu i vašim odgovorima.",
  "would-also-like-to-rate-us-on-google":
    "Želite li nas također ocijeniti na Googleu?",
  "rate-us-now": "Ocijenite nas sada",

  // Negative Chat Reply
  "select-skill": "Odaberite vještinu",
  "none-selected": "Ništa nije odabrano",
  "can-we-get-in-touch-with-you-about-your-experience-today":
    "Možemo li vas kontaktirati u vezi s vašim današnjim iskustvom?",
  "write-here": "Pišite ovdje...",
  "please-can-we-get-your-name": "Možete li nam reći svoje ime?",
  "please-enter-your-email": "Unesite svoju e-poštu:",
  "enter-your-phone-number": "Unesite svoj broj telefona:",
  "please-tell-us-a-bit-more-about-your-experience":
    "Recite nam nešto više o svom iskustvu:",
  "you-have-already-submitted-rating": "Već ste poslali ocjenu",
  "sorry-to-hear-you-didn-t-have-the-best-experience-today-with-us-please-could-you-highlight-what-went-wrong":
    "Žao nam je čuti da danas niste imali najbolje iskustvo s nama, možete li istaknuti što je pošlo po zlu?",

  // Positive Chat Reply
  "select-employee": "Odaberite zaposlenika",
  "we-d-love-to-know-who-looked-after-you-today":
    "Voljeli bismo znati tko se danas brinuo o vama?",
  "what-stood-out-to-you-today": "Što vam se danas istaknulo?",
  "did-we-provide-exceptional-service-today":
    "Jesmo li danas pružili iznimnu uslugu?",
  "do-you-have-any-comments-or-feedback-about-your-experience-with-us-today":
    "Imate li kakvih komentara ili povratnih informacija o svom današnjem iskustvu s nama?",

  // Client Connect Director
  "message-from-leadership": "Poruka uprave",
  "message-from-leadership-text":
    "Neprestano tražim načine kako poboljšati našu ponudu za naše klijente. Postoje li, prema vašem mišljenju, aspekti koje bismo mogli poboljšati?",
  "client-connect-director-another-note":
    "Usput, ako postoji određena tema kojom biste željeli da se naš tim pozabavi, slobodno je podijelite. Ovdje sam ne samo da slušam, već i da se uključim i djelujem na temelju vaših briga ili ideja.",
  "your-message-here": "Vaša poruka ovdje",
  "visit-information": "Informacije o posjetu",
  "visit-time-out": "Vrijeme odlaska",
  "contact-information": "Kontakt informacije",
  "client-connect-director-contact-information-text":
    "Kako bismo pružili bolju pomoć, ljubazno molimo vaše podatke, uključujući vaše ime, adresu e-pošte i kontakt broj. Te će nam informacije omogućiti da vam brzo odgovorimo i kontaktiramo vas.",
  name: "Ime",
  "enter-your-name": "Unesite svoje ime",
  email: "E-pošta",
  "enter-your-email": "Unesite svoju e-poštu",
  "contact-number": "Kontakt broj",
  "please-enter-your-name": "Unesite svoje ime",
  "please-enter-your-email-or-phone-number":
    "Unesite svoju e-poštu ili broj telefona",
  "invalid-email-address": "Nevažeća adresa e-pošte",
  "invalid-phone-number-format": "Nevažeći broj telefona za odabranu zemlju.",
  "no-match-found": "Nema podudaranja",
  "phone-number-must-be-digits-for-country":
    "Broj telefona mora imati {count} znamenki za odabranu zemlju ({current}/{count}).",
  "phone-number-must-be-digits-range-for-country":
    "Broj telefona mora imati {min}–{max} znamenki za odabranu zemlju ({current}/{max}).",
  "please-select-time": "Odaberite vrijeme",
  "you-must-provide-at-least-one-answer-before-submitting-the-survey":
    "Morate dati barem jedan odgovor prije slanja ankete.",

  // Mobile Survey Questions CheckBoxType
  comment: "Komentar",
  "comment-is-required": "Komentar je obavezan!",
  "minimum-selection-is": "Minimalni odabir je {min_options}",
  "maximum-selection-is": "Maksimalni odabir je {max_options}",
  "this-question-is-required": "Ovo pitanje je obavezno!",
  "please-fill-all-required-grid-rows": "Ispunite sve obavezne retke tablice!",
  "please-fill-mandatory-fields-to-continue":
    "Ispunite obavezna polja za nastavak",

  // Mobile Survey Questions CommentsAndImage
  "please-select-valid-image-files": "Odaberite valjane slikovne datoteke.",

  // Mobile Survey Questions EmployeeType
  loading: "Učitavanje",
  "getting-employee": "Dohvaćanje zaposlenika...",

  // Mobile Survey Questions FileUploadType
  "please-select-valid-image-or-video-files":
    "Odaberite valjane slikovne ili videodatoteke.",
  "please-select-a-valid-file":
    "Odaberite valjanu datoteku (slika, video, PDF ili Word).",

  // Mobile Survey Questions NumberType
  "please-enter-a-number-without-any-decimal-points":
    "Unesite broj bez decimalnih mjesta.",
  "please-enter-a-number-less-than-or-equal-to":
    "Unesite broj manji ili jednak {max_number_value}.",

  // Mobile Survey Questions SignatureType
  "please-complete-your-signature": "Dovršite svoj potpis.",

  // Mobile Survey Questions TextType
  "please-enter-valid-email-address": "Unesite valjanu adresu e-pošte.",
  "phone-number-should-be-10-digit": "Broj telefona treba imati 10 znamenki.",
  "please-enter-at-least-characters":
    "Unesite barem {minimum_character} znakova.",
  "select-date": "Odaberite datum",
  "select-time": "Odaberite vrijeme",
  "client-connect-date-picker-aria": "Datum: {value}. Otvori birač datuma",
  "client-connect-time-picker-aria": "Vrijeme: {value}. Otvori birač vremena",
  "select-country": "Odaberite državu",

  // Report Page
  "click-the-link-to-see-how": "Kliknite poveznicu da vidite kako.",
  "adding-your-teams-to-the-ServeFirst-reporting-platform":
    "Dodavanjem svojih timova na ServeFirst platformu za izvještavanje i oni se mogu prijaviti kako bi vidjeli svoj učinak; također imate mogućnost upravljati svojim timom i pristupiti dodatnim izvještajima kako biste razumjeli kako općenito poslujete -",
  "did-you-know": "Jeste li znali..",
  count: "broj",
  average: "prosjek",
  focus: "fokus",
  performance: "Učinak",
  "you-can-create-bespoke-action-plans":
    "Možete izraditi prilagođene akcijske planove koji se filtriraju izravno ovdje ako su izrađeni unutar vašeg ServeFirst računa; ovdje možete odmah izrađivati radnje, vremenske okvire i vlasnike uz praćenje učinka. -",
  "no-of-times-raised": "Broj puta pokrenuto",
  action: "Radnja",
  "attribute-name": "Naziv atributa",
  "action-plan": "Akcijski plan",
  "that-by-adding-your-teams-to-the-ServeFirst-reporting-platform":
    "Dodavanjem svojih timova na ServeFirst platformu za izvještavanje i oni se mogu prijaviti kako bi vidjeli svoj učinak; također imate mogućnost upravljati svojim timom i pristupiti dodatnim izvještajima kako biste razumjeli kako općenito poslujete -",
  result: "Rezultat",
  category: "Kategorija",
  "your-location-vs-all-location": "Vaša lokacija u odnosu na sve lokacije",
  "net-promoter-score": "Net Promoter Score",
  "responses-breakdown": "Raščlamba odgovora",
  "trended-net-promoter-score": "Net Promoter Score s trendom",
  "trended-results": "Rezultati s trendom",
  "net-promoter-score-info":
    "Net Promoter Score temelji se na % promotora (ocjena 5/5) - % detraktora (ocjena 1, 2 ili 3); više o Net Promoter Scoreu možete saznati klikom na sljedeće",
  "customer-feedback": "Povratne informacije kupaca",
  logan: "Logan",
  "top-performer": "Najuspješniji",
  "rank-in-the-country": "Rang u državi",
  "ytd-score": "Rezultat od početka godine",
  "score-during-period": "Rezultat tijekom razdoblja",
  "0-from-last-month": "0 od prošlog mjeseca",
  "total-responses-for-july-2021": "Ukupno odgovora za srpanj 2021.",
  promoter: "Promotor",
  "from-04-sep-2021-to-06-sep-2021": "Od 04. ruj. 2021. do 06. ruj. 2021.",
  "the-focus-currently-is-on": "Fokus je trenutačno na",
  "1-number-of-customers-have-stated-this-as-an-opportunity":
    "1 kupac naveo je ovo kao priliku.",
  "focus-for-the-month": "Fokus za mjesec",
  "download-pdf": "Preuzmi pdf",

  // Report Page New Report
  "total-responses": "Ukupno odgovora",
  duration: "Trajanje",
  "customers-have-stated-this-as-an-opportunity":
    "kupaca navelo je ovo kao priliku",
  "error-fetching-params": "Pogreška pri dohvaćanju parametara!",
  "previous-days-was": "Prethodnih {days} dana bilo je {score}",

  // Report Page Common LgCard
  "raised-on": "# Pokrenuto",
  results: "Rezultati",

  // Report Page Components AiSuggestions
  "analyzing-data-please-wait": "Analiziranje podataka, pričekajte...",

  // Report Page Components CustomerFeedBack
  "view-report": "Prikaži izvještaj",
  "received-on": "Primljeno",

  // Report Page Components ResponseBreakdown
  detractors: "Detraktori",
  nps: "NPS",

  // Report Page Components TrendResults
  "trend-results": "Rezultati trenda",

  // Survey helpers Utils
  "failed-to-fetch-the-pdf-file": "Dohvaćanje PDF datoteke nije uspjelo",
  "error-generating-pdf-thumbnail": "Pogreška pri generiranju PDF sličice",
  "error-in-thumbnail-generation-function":
    "Pogreška u funkciji generiranja sličice",
  "failed-to-generate-pdf-thumbnail": "Generiranje PDF sličice nije uspjelo",

  // Survey Pages Audition
  "select-audit": "Odaberite reviziju",

  // Survey Pages ClientConnect
  "select-atleast-min-options": "Odaberite barem {minOptions} opcija",
  "select-max-options": "Dopušteno je najviše {maxOptions} opcija!",
  "error-saving-your-response": "Pogreška pri spremanju vašeg odgovora!",
  "failed-to-load-the-file": "Učitavanje datoteke nije uspjelo!",
  "open-link": "Otvori poveznicu",
  download: "Preuzmi",
  details: "Detalji",
  title: "Naslov",
  description: "Opis",
  "general-info": "Opće informacije",
  type: "Vrsta",
  size: "Veličina",
  "uploaded-by": "Učitao",

  // Survey Pages ClientConnect Intro
  "thank-you-for-your-time": "Hvala vam na vremenu!",

  // Survey Pages ClientConnect Content
  "review-content": "Pregledaj sadržaj",

  // Survey Pages ClientConnect Survey
  "please-give-us-your-feedback": "Dajte nam svoje povratne informacije",
  "enter-your-response": "Unesite svoj odgovor",

  // Client Connect v2 (accordion UI)
  "client-connect-preview-hey": "Pozdrav, {name}",
  "client-connect-preview-sent-from": "Poslano od {sender} - {date}",
  "client-connect-preview-step-of": "Korak {current} od {total}",
  "client-connect-preview-getting-started": "Početak",
  "client-connect-preview-getting-started-desc":
    "Pogledajte uvodne resurse pripremljene za vas.",
  "client-connect-preview-share-feedback": "Podijelite povratne informacije",
  "client-connect-preview-share-feedback-desc":
    "Vaše mišljenje pomaže nam stvoriti bolje iskustvo za vas.",
  "client-connect-preview-talk-leadership": "Razgovor s vodstvom",
  "client-connect-preview-talk-leadership-desc":
    "Pročitajte poruku vodstva i spremite svoj odgovor.",
  "client-connect-preview-reviewed-these": "Pregledao/la sam ovo",
  "client-connect-preview-send-feedback": "Pošalji povratne informacije",
  "client-connect-preview-finish-submit": "Završi i pošalji",
  "client-connect-preview-save-finish": "Završi i pošalji",
  "client-connect-preview-your-reply": "Vaš odgovor",
  "client-connect-preview-saved": "Spremljeno",
  "client-connect-preview-edit": "Uredi",
  "client-connect-preview-pop-out": "Otvori u prozoru",
  "client-connect-preview-open": "Otvori",
  "client-connect-preview-view": "Pregledaj",
  "client-connect-preview-welcome": "Dobrodošli",
  "client-connect-preview-feedback": "Povratne informacije",
  "client-connect-preview-save-message": "Pošalji poruku",
  "client-connect-preview-message-footer":
    "Vaša poruka ide izravno vodstvenom timu.",
  "client-connect-preview-leadership-placeholder": "Unesite svoju poruku...",
  "client-connect-preview-thank-you": "Hvala",
  "client-connect-preview-thank-you-body":
    "Završili ste Client Connect. Vaši odgovori na anketu i poruka poslani su timu — uskoro će vas kontaktirati.",
  "client-connect-thank-you-message":
    "Hvala vam na vremenu. Vaše povratne informacije zaista znače.",
  "client-connect-preview-review-answers": "Pregledaj moje odgovore",
  "client-connect-preview-back-dashboard": "Natrag na nadzornu ploču",
  "client-connect-preview-already-submitted":
    "Vaše povratne informacije su primljene. Hvala vam! Slobodno istražite materijale iznad.",
  "enter-email-address": "Unesite e-poštu",
  "enter-phone-no": "Unesite telefonski broj",
  "product-type": "Vrsta proizvoda",
  "enter-number": "Unesite broj",
  aspect: "Aspekt",

  // Survey Pages ClientConnect Director
  "i-am-constantly-seeking-ways-to-better-our-offerings-for-our-clientele":
    "Neprestano tražim načine kako poboljšati našu ponudu za naše klijente. Postoje li, prema vašem mišljenju, aspekti koje bismo mogli poboljšati?",
  "on-another-note-if-there-s-a-specific-topic-you-d-like-our-team-to-address-don-t-hesitate-to-share":
    "Usput, ako postoji određena tema kojom biste željeli da se naš tim pozabavi, slobodno je podijelite. Ovdje sam ne samo da slušam, već i da se uključim i djelujem na temelju vaših briga ili ideja.",
  "to-provide-enhanced-assistance-we-kindly-ask-for-your-details-including-your-name-email-address-and-contact-number":
    "Kako bismo pružili bolju pomoć, ljubazno molimo vaše podatke, uključujući vaše ime, adresu e-pošte i kontakt broj. Te će nam informacije omogućiti da vam brzo odgovorimo i kontaktiramo vas.",

  // Survey Pages Location
  "select-the-location-you-visited": "Odaberite lokaciju koju ste posjetili",
  locations: "Lokacije",
  "is-this-your-current-location": "Je li ovo vaša trenutačna lokacija?",
  "nearest-location": "Najbliža lokacija",
  "loading-data": "Učitavanje podataka...",
  "please-wait": "Pričekajte!",

  // Survey Pages Location Area
  "location-area": "Područje lokacije",
  "select-location-area": "Odaberite područje lokacije",

  // Survey Pages Login
  "please-enter-your-password": "Unesite svoju lozinku",
  "value-must-be-longer-than-3-characters":
    "Vrijednost mora biti dulja od 3 znaka",
  "please-enter-your-email-address": "Unesite svoju adresu e-pošte",
  password: "Lozinka",
  "internal-server-error": "Interna pogreška poslužitelja!",
  "sign-in": "Prijava",

  // Survey Pages SameDaySurvey
  "you-have-already-performed-this-survey": "Već ste ispunili ovu anketu!",
  "csat-link-invalid": "Ova poveznica na anketu više nije važeća.",

  // Survey Pages SurveyThankYou
  "your-feedback-has-been-submitted":
    "Vaše povratne informacije su poslane. Vaš broj prijave je #",
  "a-member-of-the-team-will-be-in-touch-shortly":
    "Član tima uskoro će vas kontaktirati.",
  "would-you-also-like-to-rate-us-on-google":
    "Želite li nas također ocijeniti na Googleu?",
  "to-review-our-terms-and-conditions-please-click":
    "Za pregled naših Uvjeta i odredbi kliknite",
  here: "Ovdje",
  "ticket-number-copied-to-clipboard": "Broj prijave kopiran u međuspremnik",

  // Survey Pages Welcome
  "visit-date": "Datum posjeta",
  "visit-time-in": "Vrijeme dolaska",
  "please-select-date": "Odaberite datum",
  "guest-info": "Informacije o gostu",
  "please-select-user": "Odaberite korisnika",
  "get-started": "Započni",

  // Survey Pages InventoryType
  "enter-value": "Unesite vrijednost",
  "getting-product-list": "Dohvaćanje popisa proizvoda...",

  // Survey Pages NotesAndImage
  "upload-file": "Učitaj datoteku",

  // Survey Pages NumberType
  "enter-digit": "Unesite znamenku",

  // Survey Pages TextArea
  "enter-your-comment": "Unesite svoj komentar",

  // Survey Pages Upload
  "file-size-should-be-less-than-10-mb":
    "Veličina datoteke mora biti manja od 10 MB",
  "drag-you-files-here-file-size-less-than-10-mb-or":
    "Povucite datoteke ovdje, veličina datoteke manja od 10 MB ili",
  "upload-or-drag-and-drop-your-files-here":
    "Učitajte ili povucite i ispustite datoteke ovdje",
  "browse-files": "Pregledaj datoteke",

  // Survey Pages Questions
  "next-question": "Sljedeće pitanje",
  "save-and-exit": "Spremi i izađi",
  "failed-to-save-and-exit":
    "Nije moguće spremiti vaš napredak. Pokušajte ponovno.",
  "progress-saved-you-may-close-this-tab":
    "Vaš napredak je spremljen. Sada možete zatvoriti ovu karticu preglednika.",
  "please-enter-at-least": "Unesite barem {min} znakova.",
  "contact-no": "Kontakt broj",
  "please-select-location": "Odaberite lokaciju!",
  "please-select-survey": "Odaberite anketu!",
  "please-enter-your-email-address-or-phone-number":
    "Unesite svoju adresu e-pošte ili broj telefona.",

  // Utils CompressFiles
  "compression-error": "Pogreška pri kompresiji:",

  // Web Rating FrontLogin
  "enter-location-id": "Unesite ID lokacije",
  "invalid-location-id": "Nevažeći ID lokacije",
  "location-id-required": "ID lokacije je obavezan",

  // Web Rating Index
  "please-tell-us-how-your-experience-was-today":
    "Recite nam kakvo je bilo vaše današnje iskustvo.",

  // Web Rating Negativefeedback
  "sorry-to-hear-you-didn-t-have-the-best-experience-today-with-us-please-could-you-highlight-what-went-wrong":
    "Žao nam je čuti da danas niste imali najbolje iskustvo s nama, možete li istaknuti što je pošlo po zlu?",
  "enter-valid-email-address": "Unesite valjanu adresu e-pošte.",
  "can-we-get-in-touch-with-you": "Možemo li vas kontaktirati?",

  // Web Rating Positivefeedback
  "enter-your-telephone-number": "Unesite svoj telefonski broj",
  "write-your-feedback": "Napišite svoje povratne informacije",

  // Web Rating Positivefeedback2
  "what-made-the-employee-name-stand-out-to-you":
    "Po čemu se {employeeName} istaknuo za vas?",
  team: "Tim",

  // Web Rating PositivefeedbackForm
  "please-go-to-previous-step-and-select-employee-without-employee-selection-not-able-to-submit-feedback-form":
    "Vratite se na prethodni korak i odaberite zaposlenika; bez odabira zaposlenika nije moguće poslati obrazac s povratnim informacijama",
  "share-us-your-experience-with-us-today":
    "Podijelite s nama svoje današnje iskustvo...",
  "did-employee-name-provide-exceptional-service":
    "Je li {employeeName} pružio iznimnu uslugu?",
  "did-employee-name-stand-out-for-delivering-exceptional-service":
    "Je li se {employeeName} istaknuo u pružanju iznimne usluge?",

  // Web Rating New apiHelpers loginHelpers
  "please-enter-user-name": "Unesite korisničko ime",
  "please-enter-password": "Unesite lozinku",

  // Web Rating New RatingLocations
  search: "Pretraži",
  "select-loction-to-ratings": "Odaberite lokaciju za ocjenjivanje",
  location: "Lokacija",
  "is-this-your-location": "Je li ovo vaša lokacija?",
  "fetch-details-failed": "Dohvaćanje detalja nije uspjelo",

  // Web Rating New PositiveJourny EmployeDetail
  "click-as-many-as-you-want": "Kliknite koliko god želite",
  "what-made-employee-name-stand-out-to-you":
    "Po čemu se {employeeName} istaknuo za vas?",
  "what-made-the-team-stand-out-to-you": "Po čemu se tim istaknuo za vas?",

  // Web Rating New PositiveJourny EmployeService
  "did-we-stand-out-for-delivering-exceptional-service":
    "Jesmo li se istaknuli u pružanju iznimne usluge?",

  // Web Rating New NegativeJourny EmployePersonalDetail
  "leave-an-email-or-phone-number-if-you-want-us-to-get-in-touch-otherwise-just-leave-it-blank-then-press-next":
    "Ostavite e-poštu ili broj telefona ako želite da vas kontaktiramo, u protivnom ostavite prazno pa pritisnite Dalje",
  "anything-else-you-d-like-to-share": "Želite li još nešto podijeliti?",
  "enter-valid-email": "Unesite valjanu e-poštu",
  message: "Poruka",
  "by-signing-up-the-form-you-agree-to-our-terms-and-privacy":
    "Ispunjavanjem obrasca pristajete na naše Uvjete i Pravila privatnosti.",

  // Web Rating New FrontWebLogin
  login: "Prijava",
  username: "Korisničko ime",

  // Web Rating New FrontRating
  "press-the-facial-expression-that-best-represents-how-you-feel-about-your-experience":
    "Pritisnite izraz lica koji najbolje predstavlja kako se osjećate u vezi sa svojim iskustvom.",
  "getting-employee-list": "Dohvaćanje popisa zaposlenika",
  "getting-skill-data": "Dohvaćanje podataka o vještinama",
  "getting-screen-saver": "Dohvaćanje čuvara zaslona",

  // Web Rating New CommonComponents ThankYouModal
  "thank-you-for-contacting-us": "Hvala što ste nas kontaktirali.",
  "we-ll-be-in-touch-very-soon": "Javit ćemo vam se vrlo brzo.",

  // Web Rating New CommonComponents GoogleQrPage
  "you-can-follow-this-button-to-rate-us-on-google":
    "Možete pratiti ovaj gumb kako biste nas ocijenili na Googleu",
  "rate-us-on-google": "Ocijenite nas na Googleu",

  // Web Rating New CommonComponents ContactUsModal
  "contact-us": "Kontaktirajte nas",
  "or-you-may-reach-us-on": "...ili nas možete kontaktirati na.",
  "do-you-want-to-learn-more-about-serve-first":
    "Želite li saznati više o Serve Firstu?",

  // Web Rating New CommonComponents BottomBar
  saving: "Spremanje",
  "please-enter-only-digits-for": "Unesite samo znamenke za",
  "please-enter": "Unesite",
  "enter-value-here": "Unesite vrijednost ovdje",

  // Survey Pages Questions Dropdown
  "please-select": "Odaberite",
  "survey-retry-message": "Moći ćete ispuniti ovu anketu nakon {value} {unit}.",
  minute: "minuta",
  minutes: "minuta",
  hour: "sat",
  hours: "sati",
  day: "dan",
  days: "dana",
  week: "tjedan",
  weeks: "tjedana",
  month: "mjesec",
  months: "mjeseci",
  clear: "Očisti",

  "powered-by": "Pokreće",
  "image-is-required": "Slika je obavezna",
  "please-fill-all-required-contact-information":
    "Ispunite sve obavezne kontakt informacije",

  "please-leave-any-extra-feedback-in-the-box-below":
    "Ostavite dodatne povratne informacije u okviru ispod.",
  "all-feedback-is-confidential": "Sve povratne informacije su povjerljive",
  "your-feedback-has-been-received-thank-you":
    "Vaše povratne informacije su zaprimljene, hvala vam",
  "close-page": "Zatvori stranicu",
  send: "Pošalji",
  sending: "Slanje",
  "enter-your-feedback-here": "Unesite svoje povratne informacije ovdje",
  "for-anything-else-please": "Za sve ostalo ",
  "please-correct-the-custom-field-values":
    "Ispravite vrijednosti prilagođenih polja",
  "please-complete-all-required-contact-information":
    "Ispunite sve obavezne kontakt informacije",
  "survey-cannot-be-submitted": "Anketu nije moguće poslati",
  "please-enter-your-phone": "Unesite svoj telefon",
  "network-error-please-try-again":
    "Pogreška mreže. Provjerite svoju vezu i pokušajte ponovno.",
  "no-results-found": "Nema pronađenih rezultata",
  "drop-files-here": "Ispustite datoteke ovdje...",
  "drag-drop-files":
    "Povucite i ispustite datoteke ovdje ili kliknite za odabir datoteka",
  "max-5-files-5mb": "Najviše 5 datoteka, po 5 MB, samo slike",
  remove: "Ukloni",

  // Learning & Development

  "ld-module-title": "Učenje i razvoj",
  "ld-no-sign-in-required": "Prijava nije potrebna",
  "ld-progress-warning":
    "Ne zatvarajte ovaj prozor — vaš napredak se ne sprema i morali biste početi ispočetka.",
  "ld-loading-module": "Učitavanje modula za učenje…",
  "ld-unable-load-module": "Nije moguće učitati modul za učenje.",
  "ld-package-not-configured": "Paket za učenje nije konfiguriran.",
  "ld-start-guidance": "Započni obuku",
  "ld-due-date": "Rok {date}",
  "ld-whats-involved": "Što je uključeno",
  "ld-your-progress": "VAŠ NAPREDAK",
  "ld-step-of": "Korak {current} od {total}",
  "ld-watched-in-full": "Pogledano u cijelosti",
  "ld-video-no-skip": "Možete premotati unatrag, ali ne unaprijed",
  "ld-video-muted-counts": "Utišano — reprodukcija se i dalje računa",
  "ld-maximize-document": "Povećaj dokument",
  "ld-minimize-document": "Smanji dokument",
  "ld-read-percent": "{percent} % pročitano",
  "ld-end-of-document": "Kraj dokumenta",
  "ld-scroll-to-continue": "Pomaknite za nastavak",
  "ld-read-to-end": "Pročitano do kraja",
  "ld-read-to-end-to-continue": "Pročitajte do kraja za nastavak",
  "ld-loading-document": "Učitavanje dokumenta…",
  "ld-pdf-preview-unavailable":
    "Nije moguće pregledati ovaj PDF u pregledniku.",
  "ld-pdf-page-alt": "{title} — stranica {page}",
  "ld-knowledge-check": "PROVJERA ZNANJA",
  "ld-knowledge-check-title": "{title} — provjera znanja",
  "ld-quiz-instruction":
    "Odgovorite na {count, plural, one {# pitanje} few {# pitanja} other {# pitanja}}. Prolazni prag {passMark} %.",
  "ld-quiz-instruction-pass-only": "Prolazni prag {passMark} %.",
  "ld-question-of": "PITANJE {current} OD {total}",
  "ld-guidance-of": "OBUKA {current} OD {total}",
  "ld-loading-questionnaire": "Učitavanje upitnika…",
  "ld-preparing-questions": "Priprema vaših pitanja",
  "ld-submit-answers": "Pošalji odgovore",
  "ld-submitting": "Slanje…",
  "ld-ready-to-submit": "Spremno za slanje odgovora",
  "ld-answer-selected": "Odgovor odabran",
  "ld-select-answer": "Odaberite jedan odgovor za nastavak",
  "ld-pass-mark-note":
    "Potrebno vam je {passMark} % ili više da položite. Odgovori se ne mogu mijenjati nakon slanja.",
  "ld-questionnaire-not-configured": "Upitnik nije konfiguriran.",
  "ld-unable-load-questionnaire": "Nije moguće učitati upitnik.",
  "ld-no-visible-questions":
    "Trenutačno nema dostupnih pitanja za ovu provjeru znanja.",
  "ld-unable-submit-answers": "Nije moguće poslati odgovore. Pokušajte ponovo.",
  "ld-not-passed": "Nije položeno",
  "ld-completed": "Dovršeno",
  "ld-fail-title": "Skoro ste uspjeli — pokušajte ponovo",
  "ld-fail-description":
    "Ostvarili ste {score} — prolazni prag je {passMark} %. Preostalo vam je {remaining}.",
  "ld-attempts-remaining":
    "{count, plural, one {# pokušaj} few {# pokušaja} other {# pokušaja}}",
  "ld-attempt-of": "Pokušaj {current} od {total}",
  "ld-fail-alert":
    "Odvojite trenutak da ponovno pregledate vodič, zatim ponovno obavite provjeru. Nakon posljednjeg pokušaja provjera će biti zaključana.",
  "ld-try-again": "Pokušaj ponovo",
  "ld-review-guidance": "Pregledaj vodič",
  "ld-locked-title": "Ova obuka je sada zaključana",
  "ld-locked-description":
    "Ostvarili ste {score} — prolazni prag za ovaj paket je {passMark} %. Iz razloga usklađenosti ne možete ga ponoviti ovdje.",
  "ld-speak-to-manager": "Razgovarajte sa svojim voditeljem",
  "ld-locked-manager-copy":
    "Vaš voditelj smjene može ponovno dodijeliti {courseTitle} kako biste mogli ponovno proći vodič i ponovno obaviti provjeru.",
  "ld-close-window": "Sada možete zatvoriti ovaj prozor.",
  "ld-close-window-safe": "Sada možete sigurno zatvoriti ovaj prozor.",
  "ld-success-title": "Čestitamo!",
  "ld-success-description":
    "Uspješno ste dovršili {courseTitle}. Ovo je zabilježeno u vašem profilu obuke — nema više ništa za učiniti.",
  "ld-email-yourself": "Pošaljite kopiju sebi",
  "ld-email-copy-description":
    "Pošaljite potvrdu o dovršetku u svoju poštu za evidenciju.",
  "ld-email-placeholder": "vi@tvrtka.hr",
  "ld-sent": "Poslano",
  "ld-sending-email": "Slanje…",
  "ld-unable-send-email": "Nije moguće poslati e-poštu. Pokušajte ponovo.",
  "ld-email-sent-success": "E-pošta o potvrdi uspješno je poslana!",
  "ld-video-briefing": "Video brifing",
  "ld-document": "Dokument",
  "ld-video-meta": "Video",
  "ld-video-meta-no-skip": "Video · bez preskakanja",
  "ld-document-meta": "Dokument · PDF",
  "ld-document-meta-scroll": "Dokument · PDF · pomaknite do kraja",
  "ld-video-instruction-full":
    "Pogledajte u cijelosti — ne možete preskakati unaprijed",
  "ld-video-instruction": "Pogledajte brifing, zatim nastavite",
  "ld-document-instruction-scroll": "Pomaknite do kraja za nastavak",
  "ld-document-instruction": "Pregledajte dokument, zatim nastavite",
  "ld-questionnaire": "Upitnik",
  "ld-confirmation": "Potvrda",
  "ld-question-count":
    "{count, plural, one {# pitanje} few {# pitanja} other {# pitanja}}",
  "ld-knowledge-check-subtitle": "Provjera znanja",
  "ld-score": "Rezultat",
  "ld-whats-involved-pass-mark":
    "Prolazni prag {passMark} % · otključava se nakon vodiča",
  "ld-document-type-pdf": "{documentType} · PDF",
};
